//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    placeholder: {
      type: String,
      default: '请输入',
    },
  },
  computed: {
    model: {
      get() {
        return this.value || '';
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    /**
     * @description 图标点击事件
     */
    iconClick() {
      this.$emit('iconClick');
    },
  },
};
